import React from 'react';
import { useAuth } from '@domain/auth/auth.hook';
import { useFormData } from '@domain/hooks/use.form.data';
import { RequestDialog } from '@components/dialog/request.dialog';
import { DescText } from '@styles/common';
import { ToggleDialogProps } from '@screens/players/player.actions/toggles/toggle.dialog.props';

const SetTesterDialog = ({ player, requestChange, ...rest }: ToggleDialogProps) => {
  const { authorizedServices } = useAuth();
  const { tester } = player.toggles;

  const formData = useFormData(player.pid, function requestPlayerAsTester(data, cancelToken) {
    return authorizedServices.patch('/admin/toggles/set-tester', { params: data, cancelToken, pid: player.pid, tester: !tester });
  });

  const props = {
    icon: 'bug_report',
    title: tester ? 'Remove tester status' : 'Set player as tester',
    successMsg: `Player ${tester ? 'is no longer' : 'is now'} a tester!`,
    onSuccess: requestChange,
  };

  return (
    <RequestDialog formData={formData} {...props} {...rest}>
      <DescText>
        Are you sure you want to <strong>{tester ? 'unset' : 'set'}</strong> this player as tester?
      </DescText>
    </RequestDialog>
  );
};

export default SetTesterDialog;
